<template>
    <c-dialog ref="dialog" title="发送补数据消息" width="600" mask-close  @resolve="submitHandle">
        <c-form ref="form" unit-width="100%">
            <c-form-item label="队列名称" required>
                <c-input v-model="formData.queues" name="queues" placeholder="请选择或输入队列名称" allow-create></c-input>
            </c-form-item>
            <c-form-item label="消息体" required>
                <c-input type="textarea" v-model="formData.message" name="message" rows="8" placeholder="请输入消息内容"></c-input>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>
export default {
    name: 'mqMessageSend',

    data() {
        return {
            formData: {
                queues: '',
                message: ''
            },
        }
    },

    methods: {
        open() {
            this.formData = {
                queues: '',
                message: ''
            };
            this.$refs.dialog.open();
        },

        submitHandle() {
            if (!this.formData.queues) {
                this.$message({message: '请选择或输入队列名称', type: 'warn'});
                return;
            }
            if (!this.formData.message || !this.formData.message.trim()) {
                this.$message({message: '请输入消息内容', type: 'warn'});
                return;
            }
            this.request({
                url: '/sys/mq/message/send',
                data: {
                    queues: this.formData.queues,
                    message: this.formData.message.trim()
                },
                loading: true,
                success: (data, message) => {
                    this.$message({
                        message: message || '消息发送成功',
                        type: 'success'
                    });
                    this.$refs.dialog.close();
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>